import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {RootState} from 'store/types';
import type {WorkItemLink, WorkItemsState} from './types';

const initialState: WorkItemsState = [];

const workItemsSlice = createSlice({
  name: 'workItems',
  initialState,
  reducers: {
    setWorkItems: (_state, action: PayloadAction<WorkItemLink[]>) => {
      return action.payload;
    },
    clearWorkItems: () => {
      return initialState;
    },
  },
});

export const {setWorkItems, clearWorkItems} = workItemsSlice.actions;
export const selectWorkItems = (state: RootState) => state.workItems;

export default workItemsSlice;
